import React from "react";
import { zip } from "lodash";

// Rendering
import { scaleLinear } from "d3-scale";
import { extent } from "d3-array";
import { interpolateLab } from "d3-interpolate";

// Alternate rendering tech
import { Stage, Layer, Circle, Line, Group } from "react-konva";
import Axes from "./axes";

export const margin = { top: 20, right: 20, bottom: 20, left: 100 };
// Lazy responsiveness
export const WIDTH = Math.max(800, window.innerWidth - margin.left - margin.right);
export const HEIGHT = Math.max(820, window.innerHeight - 300 - margin.top - margin.bottom);
export const xBounds = [margin.left, WIDTH];


// Given pair of stations, compare their speeds (envelope estimate assumes fixed speed)
const calculateSlope = (d) => {
  /* Calculates speed (miles/minute) between any two train stations. */
  const slope = Math.abs(
    (d[1].distance - d[0].distance) / (d[1].arrival_time - d[0].arrival_time)
  );
  // slopes.push(slope);
  return slope;
}

const CONFIG = {
  container: { // wrapper size including the margins
    width: WIDTH + margin.left + margin.right,
    height: HEIGHT + margin.top + margin.bottom
  }
};


const MareyChart = props => {
  const { stations, stopsByTrip } = props;
  const svgProps = {
    width: CONFIG.container.width,
    height: CONFIG.container.height + margin.top + margin.bottom
  };

  const canvasProps = {
    width: svgProps.width,
    height: svgProps.height
  };

  // Scaling Functions
  const { xScale, xScaleAxis } = props;
  const yScale = scaleLinear()
    .range([margin.top, HEIGHT])
    .domain(extent(stations, d => d.distance));

  const zScale = scaleLinear()
    // Use Pandas to check the 10th and 90th percentiles.
    // orange is faster, purple is slower
    .domain([0.000006, 0.000012])
    .range(["purple", "orange"])
    .interpolate(interpolateLab);

  const canvasClipper = (ctx) => {
    ctx.rect(margin.left, margin.top, WIDTH - margin.left, canvasProps.height)
  };

  return (
    <div id="viz" style={{ position: "relative" }}>
      {/* Circles and Lines for high performance */}
      <Stage
        width={canvasProps.width}
        height={HEIGHT}
        style={{ position: "absolute", top: margin.top }}
      >
        <Layer>
          <Group
            clipFunc={canvasClipper}
          >
            {stopsByTrip.flatMap((tripStops, i) =>
              tripStops.values.map((stop, j) => (
                <Circle
                  key={`${stop.trip_id}-${j}`}
                  x={xScale(stop.arrival_time)}
                  y={yScale(stop.distance)}
                  radius={j === 0 ? 2.5 : 2}
                  fill="black"
                  opacity={j === 0 ? 0.7 : 0.2} // initial stops are darker
                  onClick={() => console.log(stop)}
                />
              ))
            )}
            {stopsByTrip.flatMap((tripStops, i) => {
              // Rolling window of trip starts/stops
              return zip(
                tripStops.values.slice(0, tripStops.values.length - 1),
                tripStops.values.slice(1)
              ).map((pair, j) => {
                const [start, stop] = pair;
                return (
                  <Line
                    key={`${i}-${j}`}
                    points={[
                      xScale(start.arrival_time),
                      yScale(start.distance),
                      xScale(stop.arrival_time),
                      yScale(stop.distance)
                    ]}
                    strokeWidth={1.5}
                    opacity={0.25}
                    // stroke="gray"
                    stroke={zScale(calculateSlope(pair))}
                  />
                );
              });
            })}

          </Group>

        </Layer>
      </Stage>
      <Axes
        stations={stations}
        svgProps={svgProps}
        xScale={xScale}
        xScaleAxis={xScaleAxis} // axis that doesn't ever move
        yScale={yScale}
        margin={margin}
        />
    </div>
  );
};

export default MareyChart;
